import { render, staticRenderFns } from "./SoftwareUpdateSuccess.vue?vue&type=template&id=15b380f1&scoped=true"
import script from "./SoftwareUpdateSuccess.vue?vue&type=script&lang=js"
export * from "./SoftwareUpdateSuccess.vue?vue&type=script&lang=js"
import style0 from "./SoftwareUpdateSuccess.vue?vue&type=style&index=0&id=15b380f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b380f1",
  null
  
)

export default component.exports